import { t as tr } from './i18n.js'
import { useEffect, useRef, useState } from 'react'
import { ChevronDown } from 'lucide-react'

export interface MenuItem { label: string; tip?: string; danger?: boolean; onClick: () => void }

/** Compact per-row actions menu so table rows never overflow their frame. */
export function RowMenu({ label = 'Actions', items }: { label?: string; items: MenuItem[] }) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false) }
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDoc); document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey) }
  }, [open])
  return (
    <div className="menu" ref={ref}>
      <button className="button sm" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((o) => !o)} data-tip={tr("More actions for this row")}>{label} <ChevronDown size={14} strokeWidth={2} aria-hidden /></button>
      {open && (
        <div className="menupop" role="menu">
          {items.map((it) => <button key={it.label} role="menuitem" className={`menuitem ${it.danger ? 'danger' : ''}`} data-tip={it.tip} onClick={() => { setOpen(false); it.onClick() }}>{it.label}</button>)}
        </div>
      )}
    </div>
  )
}
